const logotext = "TK";
const meta = {
    title: "TRIDEEP KUMAR H",
    description: "I'm Trideep Kumar , a Fullstack developer and Javascript enthuist.",
};

const introdata = {
    title: "Hi, I'm Trideep Kumar",
    animated: {
        first: "Fullstack developer",
        second: "MERN Enthusiast",
        third: "React Developer",
        fourth: "Web Developer",
        fifth: "Software Developer",

    },
    description: "Self taught full-stack developer with hands-on experience in creating web applications using various technologies. Aspiring to utilize self-learned skills and knowledge in a challenging and dynamic environment. Able to work independently or collaboratively, delivering high-quality results within deadlines.",
    your_img_url: "https://res.cloudinary.com/dbnrosh3i/image/upload/v1698393897/portfolio6_n5ncc6.png",
};

const dataabout = {
    title: "Who am I?",
    aboutme: "I'm Trideep Kumar, a passionate MERN Stack Developer with a strong commitment to crafting exceptional web applications. As a self-taught full-stack developer, I've honed my skills in a dynamic, ever-evolving tech landscape. My journey in the world of web development has equipped me with hands-on experience in using a diverse range of technologies. I have a knack for turning ideas into functional, user-friendly web solutions that deliver exceptional value. Whether I'm working independently or as part of a team, I'm dedicated to producing high-quality results within set deadlines. I take pride in my ability to tackle challenging projects and thrive in a fast-paced, collaborative environment."
};



const skills = [{
    name: "MongoDB",
},

{
    name: "Express.js",
},

{
    name: "React",
},

{
    name: "Node.js",
},

{
    name: "Git",
},

{
    name: "MVC",
},

{
    name: "Nginx",
},

{
    name: "Redux toolkit",
},
];

const dataportfolio = [{
    img: "https://res.cloudinary.com/dbnrosh3i/image/upload/v1698385565/portfolio1_ezgk8p.jpg",
    description: "E-commerce website for selling milk and milk products.",
    link: "https://thecowboy.shop/",
},
{
    img: "https://res.cloudinary.com/dbnrosh3i/image/upload/v1688990272/u24pzwmre6hdprie18nb.png",
    description: "Job Portal application with user, organisation and admin panels .",
    link: "https://jobcy-git-main-trideepkumar.vercel.app/signup",
},
{
    img: "https://res.cloudinary.com/dbnrosh3i/image/upload/v1698387295/portfolio2_xqupsq.webp",
    description: "TUtilised Redux for state management.",
    link: "https://github.com/trideepkumar/REACT_USER_ADMIN_AUTHENTICATION",
},

{
    img: "https://res.cloudinary.com/dbnrosh3i/image/upload/v1698387576/portfolio3_dmlzgp.webp",
    description: "Implemented the TMDB API to create a dynamic movie streaming experience.",
    link: "https://github.com/trideepkumar/NETFLIX_CLONE",
},
{
    img: "https://res.cloudinary.com/dbnrosh3i/image/upload/v1698387775/portfolio4_xtunko.png",
    description: "Integrated firebase as the backend.",
    link: "https://github.com/trideepkumar/OLX_CLONE_REACT",
},
{
    img: "https://res.cloudinary.com/dbnrosh3i/image/upload/v1698388153/portfolio5_bxtu7f.png",
    description: "Todo Application using Typescript",
    link: "https://github.com/trideepkumar/TODO_TYPESCRIPT",
},
];

const contactConfig = {
    YOUR_EMAIL: "trideepkumar.h@gmail.com",
    description: "Looking forward to hearing from you!",
    YOUR_SERVICE_ID: "service_z2i18dr",
    YOUR_TEMPLATE_ID: "template_yw1ue3c",
    YOUR_USER_ID: "1qnHFjT9MbiPnHxC2",
};

const socialprofils = {
    github: "https://github.com/trideepkumar",
    linkedin: "https://www.linkedin.com/in/trideep-kumar-h/",
};
export {
    meta,
    dataabout,
    dataportfolio,
    skills,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};